import { pathOr } from 'ramda';

import { types } from './actions';

const initialState = {
  isLoading: false,
  isWorkflowStatusOverviewModalOpen: false,
  quote: null,
  quoteId: null,
  quoteWorkflow: null,
};

const reducer = (state = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case types.CLOSE:
      return {
        ...initialState,
      };
    case types.OPEN_ERROR:
      return {
        ...initialState,
      };
    case types.OPEN_REQUEST:
      return {
        ...state,
        isLoading: true,
        isWorkflowStatusOverviewModalOpen: true,
        quoteId: payload.quoteId,
      };
    case types.OPEN_SUCCESS:
      return {
        ...state,
        isLoading: false,
      };
    case types.RECEIVE_QUOTE:
      return {
        ...state,
        quote: payload.quote,
      };
    case types.RECEIVE_QUOTE_WORKFLOW:
      return {
        ...state,
        quoteWorkflow: payload.quoteWorkflow,
      };
    default:
      return state;
  }
};

export default reducer;

const getScope = (state) =>
  state.modules.common.modals.workflowStatusOverviewModal;

export const getIsLoading = (state) => getScope(state).isLoading;

export const getIsModalOpen = (state) =>
  getScope(state).isWorkflowStatusOverviewModalOpen;

export const getQuote = (state) => getScope(state).quote;

export const getQuoteWorkflowSteps = (state) =>
  pathOr([], ['quoteWorkflow', 'steps'], getScope(state));
